import { cn } from '#src/styling/cn.ts';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import { Label as Primitive } from 'radix-ui';
import type { ComponentProps } from 'react';

const labelVariants = cva(
  'text-sm leading-none font-bold peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
);

export type LabelProps = ComponentProps<typeof Primitive.Root> & VariantProps<typeof labelVariants>;

export const Label = ({ className, ...props }: LabelProps) => (
  <Primitive.Root className={cn(labelVariants(), className)} {...props} />
);
